import { useState } from 'react';
import type { AnimalHealthState } from '@tendedloop/shared';
import { HEALTH_FILTERS, HEALTH_COLORS, HEALTH_SHAPES, HEALTH_LABELS } from '@/utils/animalHealth';

interface AnimalCardProps {
  slug: string;
  name: string;
  thumbPath: string;
  amenityName: string;
  healthState: AnimalHealthState;
  onClick: () => void;
}

export default function AnimalCard({ name, thumbPath, amenityName, healthState, onClick }: AnimalCardProps) {
  const [imgError, setImgError] = useState(false);

  return (
    <button
      type="button"
      onClick={onClick}
      className="flex flex-col items-center gap-1.5 rounded-xl bg-card p-2 shadow-sm transition-transform active:scale-95 focus:outline-none focus-visible:ring-2 focus-visible:ring-forest"
    >
      <div className="relative h-20 w-20 overflow-hidden rounded-lg bg-stone-50">
        {imgError ? (
          <div className="flex h-full w-full items-center justify-center bg-muted text-xl font-bold text-muted-foreground">
            {name.charAt(0).toUpperCase()}
          </div>
        ) : (
          <img
            src={thumbPath}
            alt={`${name} - ${HEALTH_LABELS[healthState]}`}
            className={`h-full w-full object-contain p-1 ${HEALTH_FILTERS[healthState]}`}
            onError={() => setImgError(true)}
            loading="lazy"
          />
        )}
        <span
          className={`absolute bottom-1 end-1 h-2.5 w-2.5 border border-white ${HEALTH_COLORS[healthState]} ${HEALTH_SHAPES[healthState]}`}
          aria-hidden="true"
        />
      </div>
      <span className="w-full truncate text-center text-xs font-semibold text-foreground">{name}</span>
      <span className="w-full truncate text-center text-[10px] text-muted-foreground">{amenityName}</span>
    </button>
  );
}
